var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.visible)?_c('v-btn',_vm._g(_vm._b({},'v-btn',{ ..._vm.$props, ..._vm.$attrs },false),_vm.$listeners),[_vm._t("default")],2):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }